import 'core-js';
import { Logger } from '_common/services';

// custom polyfills
import './polyfills/elementInViewport';
// import './polyfills/charcodePolyfill';

window.global ||= window;

import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from 'router/index';
import { Provider } from 'react-redux';
import App from 'App/App';
import Intl from 'Intl/Intl';
import { getDoDOCAppConfig } from 'dodoc.config';
import { persistor, store } from '_common/redux';
import { LoadingPage, ErrorBoundary } from '_common/components';
import setupSentry from 'sentry';
import { PersistGate } from 'redux-persist/integration/react';

// Stylesheets
import 'react-virtualized/styles.css';
import 'assets/styles/global.scss';
import 'mathjax/es5/tex-mml-svg';

import './index.css';
import setupGTM from 'GoogleTagManager/GTM';

global.logger = global.logger || Logger;
Object.typedKeys = Object.keys as any;

// MathJax configs
// MathJax.options.enableMenu = false;

getDoDOCAppConfig().then((config) => {
  //! Sentry should probably be initialized earlier, before other imports
  setupSentry(config);
  if (config.logger?.level) {
    Logger.setLogLevel(config.logger?.level);
  }

  setupGTM(config.gtm.id);

  const container = document.getElementById('main');
  const root = createRoot(container!);

  root.render(
    <StrictMode>
      <BrowserRouter>
        <Provider store={store}>
          <Intl>
            <Suspense fallback={<LoadingPage />}>
              <PersistGate persistor={persistor}>
                <ErrorBoundary>
                  <App>
                    <AppRouter />
                  </App>
                </ErrorBoundary>
              </PersistGate>
            </Suspense>
          </Intl>
        </Provider>
      </BrowserRouter>
    </StrictMode>,
  );
});
